import type { Dispatch, SetStateAction } from 'react';
import * as R from 'ramda';

export function fieldsFillCounter<F>(
  fields: F,
  counter: Dispatch<SetStateAction<number>>,
  excludedCounterFields: string[] | undefined = [],
) {
  let length = 0;

  counter(0);
  const fieldsValues = Object.values(
    R.omit(['isDefault', 'name', 'isTemplateFirstCreate', 'federalLaws', ...excludedCounterFields], fields),
  );

  fieldsValues.forEach(x => {
    if (!x) {
      return;
    }
    if (Array.isArray(x)) {
      length += x.length;

      return;
    }
    if (typeof x === 'boolean') {
      length += 1;

      return;
    }
    length += 1;
  });

  counter(length);
}
